import React, { useState, useEffect } from 'react';
import { Button } from 'react-bootstrap';
import deleteIcon from '../images/delete.svg';
import usePortalService from '../services/PortalService';
import { Link, useNavigate } from 'react-router-dom';

import { Tabs, Table, Pagination } from 'antd';
import type { TabsProps, TableProps, PaginationProps } from 'antd';
import styled from "styled-components";
import { CompanyDataIsNotFilled } from '../Components/Modals/CompanyDataIsNotFilled';
import { LoaderWithTimer } from '../Components/LoaderWithTimer';
import { ManagerNavbar } from '../Components/Navbars';

const AddButton = styled(Button)`
    height: 32px; 
    width: 108px;
`
interface DataType {
    id: number;
    key: string;
    title: string;
    name: string;
    amountReactions: number;
    amountNewReactions: number;
};

const columnsVacancy: TableProps<DataType>['columns'] = [
    {
        title: 'Вакансия',
        dataIndex: 'name',
        width: '35.62%',
        key: 'name',
        render: (_, record) => (
            <Link to={"/vacancy/"+record.id}>{record.name}</Link>
        )
    },
    {
        title: 'Регион ',
        dataIndex: 'region',
        width: '30.87%',
        key: 'age'
    },
    {
        title: 'Тип',
        dataIndex: 'type',
        width: '20.55%',
        key: 'type'
    },
    {
        title: 'Отклики',
        dataIndex: 'amountReactions',
        align: 'right',
        width: '12.96%',
        key: 'amountReactions',
        render: (_, record) => (
            <>
                <Link to={"/reactionsByVacancy/"+record.id}> {record.amountReactions} </Link>
                {(record.amountNewReactions > 0) && <Link to={"/reactionsByVacancy/"+record.id} style={{color:'#F34921'}}> {' +' + record.amountNewReactions} </Link>}
            </>
        )
    }
];

export const VacanciesByCompany = () => {
    const navigate = useNavigate();

    let vacanciesPageSize = 9;
    let filterVacanciesOption: number;
    let selectedPage: number;

    const { listVacancyByCompany, deleteVacancy } = usePortalService();

    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(vacanciesPageSize);
    const [totalCount, setTotalCount] = useState(0);
    
    const [vacancies, setVacancies] = useState([]);

    const [columns, setColumns] = useState(columnsVacancy)

    const [isLoading, setIsLoading] = useState(false);
    const [hasError, setHasError] = useState(false);
    
    const [activeCount, setActiveCount] = useState(0)
    const [draftCount, setDraftCount] = useState(0)
    const [archiveCount, setArchiveCount] = useState(0)

    const [isManagerTiedToCompany, setIsManagerTiedToCompany] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);

    const columnsDraft: TableProps<DataType>['columns'] = [
        {
            title: 'Вакансия',
            dataIndex: 'name',
            width: '35.62%',
            key: 'name',
            render: (_, record) => (
                <Link to={"/createVacancy/"+record.id}>{record.name}</Link>
            )
        },
        {
            title: 'Регион ',
            dataIndex: 'region',
            width: '30.87%',
            key: 'age'
        },
        {
            title: 'Тип',
            dataIndex: 'type',
            width: '20.55%',
            key: 'type'
        },
        {
            title: 'Удалить',
            dataIndex: 'amountReactions',
            align: 'center',
            width: '12.96%',
            key: 'amountReactions',
            render: (_, record) => (
                <img 
                    src={deleteIcon} 
                    width="16px" 
                    style={{cursor:'pointer'}} 
                    onClick={() => deleteVacancyHandler(record.id)}
                />
            )
        }
    ];

    const items: TabsProps['items'] = [
        {
            key: '0',
            label: `Активные ${activeCount}`,
        },
        {
            key: '1',
            label: `Черновики ${draftCount}`,
        },
        {
            key: '2',
            label: `Архив ${archiveCount}`,
        },
    ];

    const tabHandler = (key: string) => {
        setPage(1)
        selectedPage = 1;
        filterVacanciesOption = Number(key);
        if (filterVacanciesOption === 1) {
            setColumns(columnsDraft)
        } else {
            setColumns(columnsVacancy)
        }
        showVacancies();
    };

    const pageHandler: PaginationProps['onChange'] = (pageNumber) => {
        setPage(pageNumber)
        selectedPage = pageNumber;
        showVacancies();
    };

    const pageSizeHandler: PaginationProps['onShowSizeChange'] = (current, pageSize) => {
        vacanciesPageSize = pageSize;
        setPageSize(pageSize)
    };

    const createVacancyHandler = async () => {
        if (isManagerTiedToCompany) {
            navigate("/createVacancy");
        } else {
            showModal();
        }
    }

    const showModal = () => {
      setIsModalOpen(true);
    };
  
    const closeModal = () => {
      setIsModalOpen(false);
    };

    const deleteVacancyHandler = async (id: number) => {
        const result = await deleteVacancy({
            vacancyId: String(id)
        });

        if (result.success) {
            showVacancies();
        }
    }

    useEffect(() => {
        setIsLoading(true);
        setHasError(false);
        
        filterVacanciesOption = 0
        selectedPage = 1

        listVacancyByCompany({
            offset: 0,
            "limit": vacanciesPageSize,
            "sortBy": "string",
            "sortOrder": 0,
            "filter": {
                filterOption: 0
            }
        }).then(result => {
            if (result.success) {
                setVacancies(result.vacancies.items)
                setTotalCount(result.vacancies.totalCount)
                setActiveCount(result.countVacanciesByStatus[0].count)
                setDraftCount(result.countVacanciesByStatus[1].count)
                setArchiveCount(result.countVacanciesByStatus[2].count)
                setIsManagerTiedToCompany(true);
                setIsLoading(false);
            }
        }).catch((error) => {
            setHasError(true);
            setIsLoading(false);
            console.log(error)
        });
    }, []);

    const showVacancies = async () => {
        setIsLoading(true);

        const offset = (selectedPage-1)*vacanciesPageSize;
        const result = await listVacancyByCompany({
            offset,
            "limit": vacanciesPageSize,
            "sortBy": "string",
            "sortOrder": 0,
            "filter": {
                filterOption: filterVacanciesOption
            }
        }).catch((error) => {
            setHasError(true);
            console.log(error)
        });
        if (result.success) {
            if (offset >= result.vacancies.totalCount && result.vacancies.totalCount != 0) {
                selectedPage = Math.ceil(result.vacancies.totalCount/vacanciesPageSize);
                setPage(selectedPage)
                showVacancies();
            } else {
                setVacancies(result.vacancies.items)
                setTotalCount(result.vacancies.totalCount)
                setActiveCount(result.countVacanciesByStatus[0].count)
                setDraftCount(result.countVacanciesByStatus[1].count)
                setArchiveCount(result.countVacanciesByStatus[2].count)
            }
        }
        setIsLoading(false);
    }

    return (
        <>
            <ManagerNavbar />
            <div className="vacancy-container">
                <h1 style={{ paddingBottom: '8px' }}> Вакансии </h1>
                <div className="pair-text-button">
                    <Tabs
                        defaultActiveKey="0"
                        items={items}
                        onChange={tabHandler}
                        tabBarExtraContent={<AddButton variant="primary" onClick={createVacancyHandler}> + Создать </AddButton>}
                        style={{width: "100%"}}
                    />
                </div>
                {(totalCount !== 0 && !isLoading) ?
                    <Table columns={columns} dataSource={vacancies} pagination={false} style={{marginBottom:'32px'}}/> 
                    : 
                    <LoaderWithTimer isLoading={isLoading} skeletonStyle="table" />
                } 
                {(totalCount === 0 && !isLoading && !hasError) && <p style={{paddingLeft: '20%'}}> Нет вакансий </p>}
                {(totalCount > 10 && !isLoading && !hasError) &&
                    <div className="d-flex justify-content-center">
                        <Pagination
                            current={page}
                            total={totalCount}
                            onChange={pageHandler}
                            showSizeChanger
                            pageSize={pageSize} 
                            onShowSizeChange={pageSizeHandler}
                            pageSizeOptions={[100, 50, 30, 20, 15, 9, 5]} />
                    </div>
                }
                {hasError && <p>Произошла ошибка при загрузке. Пожалуйста, попробуйте обновить страницу.</p>}
            </div>
            <CompanyDataIsNotFilled isOpen={isModalOpen} close={closeModal} />
        </>
    );
};